import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk'; // Middleware for async actions
import { composeWithDevTools } from 'redux-devtools-extension'; // Optional for debugging
import rootReducer from './rootReducer';

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk)) // Add thunk middleware
);

export default store;
